var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSgd = function SvgSgd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107530)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_107530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_107530)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V8H16V2H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43426 7.29478C4.43426 7.29478 3.02142 6.72653 3.02142 5.187C3.02142 3.64746 4.43426 3.09757 4.43426 3.09757C3.74759 2.92374 1.92554 3.07922 1.92554 5.187C1.92554 7.29478 3.72006 7.69228 4.43426 7.29478ZM4.79625 7.04032L5.20156 6.79564L5.61581 7.04032L5.51443 6.56284L5.85117 6.18617H5.39492L5.20156 5.74032L5.0082 6.18617L4.55117 6.20549L4.8887 6.56284L4.79625 7.04032ZM6.67471 6.7683L6.2694 7.01299L6.36185 6.53551L6.02432 6.17816L6.48135 6.15884L6.67471 5.71299L6.86807 6.15884H7.32432L6.98757 6.53551L7.08895 7.01299L6.67471 6.7683ZM5.64364 4.88494L6.04895 4.64025L6.46319 4.88494L6.36181 4.40746L6.69856 4.03079H6.24231L6.04895 3.58494L5.85559 4.03079L5.39856 4.05011L5.73609 4.40746L5.64364 4.88494ZM4.68496 5.61133L4.27964 5.85601L4.37209 5.37853L4.03457 5.02119L4.4916 5.00186L4.68496 4.55601L4.87832 5.00186H5.33457L4.99782 5.37853L5.0992 5.85601L4.68496 5.61133ZM6.95885 5.83407L7.36416 5.58939L7.77841 5.83407L7.67702 5.35659L8.01377 4.97992H7.55752L7.36416 4.53407L7.1708 4.97992L6.71377 4.99924L7.0513 5.35659L6.95885 5.83407Z",
    fill: "#F1F9FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSgd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SGD.249bde45c1caaa019bec365fb7adb530.svg";